import React from "react";
const Cfp = () => {
    return (
        <div className="my-24  lg:px-36 flex justify-center">
            <div class="bg-white  w-full lg:max-w-[80%]">
            </div>
        </div>
    );
}

export default Cfp